import React from 'react';
import * as S from './style';
import * as T from '../Typography';
import Button from '../Button';

const ActionCard = ({ color, to, title, subtitle, language }) => {
  return (
    <S.Card>
      <S.CardBody>
        <S.TitleWrapper>
          <T.H4Bold color={color} caps>
            {title}
          </T.H4Bold>
        </S.TitleWrapper>
        <T.Body16 color="gray3">{subtitle}</T.Body16>
      </S.CardBody>
      <Button small textColor="white" color={color} to={to} mt={3} st caps={false}>
        {language === 'english' ? 'Go' : 'Ewch'}
      </Button>
    </S.Card>
  );
};

export default ActionCard;
